/* eslint-disable @typescript-eslint/no-inferrable-types */

import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { ModalController, PopoverController, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ViewBasePage } from '../viewBase/viewBase.page';
import type { TCustomer, TTimestamp, TUser, TViewModelMessages } from '@shared/models';
import { EventsService, DateService } from '@shared/services';
import { VariablesModalPage } from '../variablesModal/variablesModal.page';

@Component({
    'selector': 'app-customerMessagesBasePage',
    'templateUrl': './customerMessagesBase.page.html',
    'styleUrls': ['./customerMessagesBase.page.scss'],
    'standalone': true,
    imports: [IonicModule, CommonModule, FormsModule]
})
// export abstract class CustomerMessagesBasePage extends ViewBasePage implements OnInit, OnDestroy {
export class CustomerMessagesBasePage extends ViewBasePage implements OnInit, OnDestroy {
    // public vm: any = {};
    protected vm: TViewModelMessages;
    protected messageNameEvent: string = '';
    protected defaultMessage: string = '';
    // protected popoverController: PopoverController;
    // protected modalController: ModalController;
    // protected eventsService: EventsService;
    // protected dateService: DateService;
    // abstract getSelectionStart(): number;
    // protected abstract elem: HTMLTextAreaElement;
    protected elem: HTMLTextAreaElement;

    constructor(injector: Injector) {
        super(injector);
        this.modalController = injector.get(ModalController);
        this.popoverController = injector.get(PopoverController);
        this.eventsService = injector.get(EventsService);
        this.dateService = injector.get(DateService);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }


    // public getSelectionStart(): number {
    public getSelectionStart(): number {
        if (this.elem) {
            return this.elem.selectionStart;
        } else {
            return 0;
        }
    }

    protected setMessageNameEvent(messageNameEvent: string) {
        this.messageNameEvent = messageNameEvent;
    }

    protected setDefaultMessage(defaultMessage: string) {
        this.defaultMessage = defaultMessage;
    }

    public supplyCustomerMenuItems(): void {
        this.pushPopoverMenuItem('Load Default Message');
        this.pushPopoverMenuItem('Show Variables');
        this.pushPopoverMenuItem('Send Message To Me');
    }

    protected async handleMenuItemClick(menuItem: any): Promise<void> {
        switch (menuItem.name) {
            case 'Load Default Message':
                this.loadDefaultMessage();
                break;

            case 'Send Message To Me':
                this.sendMessageToMe();
                break;

                // case 'Show Variables':
                //     const selectionStart = this.getSelectionStart();
                //     const msg = 'First click in the message to define where the variable should be inserted.'
                //     if (!selectionStart) {
                //         await this.uxHelperService.showAlert('Error', msg);
                //         return;
                //     }
                //     const variable = await this.showVariablesModal();
                //     if (variable) {
                //         // const rawMesssage = this.vm.rawMessage;
                //         // console.log(str.substr(3, 5));
                //         // console.log(str.slice(3, 3 + 5));

                //         // const prefix = this.vm.rawMessage.substr(0, selectionStart);
                //         // const prefix = this.vm.rawMessage.substr(0, selectionStart);
                //         // const suffix = this.vm.rawMessage.substr(selectionStart)
                //         const prefix = this.vm.rawMessage.substring(0, selectionStart);
                //         const suffix = this.vm.rawMessage.substring(selectionStart);

                //         this.vm.rawMessage = prefix + variable.name + suffix;

                //         // var elem = document.querySelector<HTMLTextAreaElement>('#rawMessage');
                //         // var elem = this.rawMessage.nativeElement as HTMLTextAreaElement;
                //         // elem.focus();
                //         // console.log(elem.selectionStart);
                //         // const ne = this.rawMessageRef.nativeElement;
                //         // const element = ne.getElement('rawMessage');
                //         // this.typeIntoInputField(ne, variable.name);
                //         // const element = this.getElement('rawMessage');

                //         // this.typeIntoInputField(this.rawMessageRef, variable.name);
                //         // this.typeIntoInputField(element, variable.name);
                //     }
            case 'Show Variables': {
                const selectionStart = this.getSelectionStart();
                if (!selectionStart) {
                    const msg = 'First click in the message to define where the variable should be inserted.';
                    await this.uxHelperService.showAlert('Error', msg);
                    return;
                }
                const variable = await this.showVariablesModal();
                if (variable) {
                    const prefix = this.vm.rawMessage.substring(0, selectionStart);
                    const suffix = this.vm.rawMessage.substring(selectionStart);

                    this.vm.rawMessage = prefix + variable.name + suffix;
                }
                break;
            }

            case 'Help':
                // this.showHelp();
                break;
        }
    }

    protected loadDefaultMessage() {
        this.vm.rawMessage = this.defaultMessage;
    }

    protected async sendMessageToMe() {
        try {
            if (!this.messageNameEvent) {
                return;
            }
            const user = this.sessionService.getCurrentUser();
            const customer: TCustomer = {
                'customerName': user.firstName + ' ' + user.lastName,
                'cellPhone': user.cellPhone,
                'isActive': true,
                'shuttleDates': [],
                'uid': '',
            };
            // const ts = this.dateService.formatTimestamp('now');
            const ts = this.dateService.now();
            customer.shuttleDates = [];
            customer.shuttleDates.push(ts);

            const data: any = { 'customers': [customer], 'debug': true };
            // this.eventsService.publish(this.messageNameEvent, data.toString());
            this.eventsService.publish(this.messageNameEvent, data);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Warning', errorMessage);
        }
    }

    protected async showVariablesModal(): Promise<any> {
        let variable = null;

        try {
            const options: any = {
                'component': VariablesModalPage,
                'componentProps': { 'vm': this.vm },
                'backdropDismiss': true,
                'showBackdrop': true,
                'cssClass': 'myModalSize'
            };

            const myModal = await this.modalController.create(options);
            await myModal.present();
            const response = await myModal.onDidDismiss();
            if (response.data.okay) {
                variable = response.data.selectedItems[0];
                return variable;
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Warning', errorMessage);
        }
    }

    // TODO: Create a method in usersService: formatUserAsCustomer(user: TUser): TCustomer
    // and call that method here
    protected formatUsersAsCustomers(users: TUser[]): TCustomer[] {
        // const selectables = [];
        const now = this.dateService.now();
        const selectables: {
            line1: string, line2: string, customerName: string,
            cellPhone: string, disabled: boolean, isActive: boolean, shuttleDates: TTimestamp[],
            uid: string, isCustomer: boolean
        }[] = [];


        users.forEach((user: TUser) => {
            selectables.push({
                'line1': user.firstName + ' ' + user.lastName,
                'line2': this.utilsService.maskPhoneNumber(user.cellPhone),
                'customerName': user.firstName + ' ' + user.lastName,
                'cellPhone': user.cellPhone,
                'disabled': false,
                'isActive': true,
                'shuttleDates': [now],
                'uid': user.uid,
                'isCustomer': false
            });
        });
        return selectables as TCustomer[];
    }
}
